import React, { useState } from 'react';
import { Info, ChevronDown } from 'lucide-react';
import { GUIDES } from './sectionGuides';

export const SectionGuide = ({ id, className = '' }) => {
  const [open, setOpen] = useState(false);
  const g = GUIDES[id];
  if (!g) return null;
  return (
    <div className={`bg-slate-800/60 border border-slate-700 rounded-xl px-4 py-3 print:hidden ${className}`} data-testid={`guide-${id}`}>
      <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-3">
        <Info className="hidden sm:block w-4 h-4 text-cyan-400 mt-0.5 shrink-0" />
        <div className="flex-1 min-w-0">
          <p className="text-sm text-slate-200" data-testid={`guide-${id}-about`}><span className="font-semibold text-white">About this page: </span>{g.about}</p>
          {open && (
            <ol className="mt-3 space-y-1.5 list-decimal list-inside text-sm text-slate-300" data-testid={`guide-${id}-steps`}>
              {g.steps.map((s) => <li key={s}>{s}</li>)}
            </ol>
          )}
          {open && g.note && <p className="mt-2 text-xs text-slate-400">{g.note}</p>}
        </div>
        <button onClick={() => setOpen(!open)} data-testid={`guide-${id}-toggle`}
          className="self-start text-xs text-cyan-300 hover:text-cyan-200 flex items-center gap-1 shrink-0 transition-colors">
          {open ? 'Hide steps' : 'How to use it'} <ChevronDown className={`w-3.5 h-3.5 transition-transform ${open ? 'rotate-180' : ''}`} />
        </button>
      </div>
    </div>
  );
};
